export const cibHouzz = ["32 32","<path d='M25.24 16v10.667l-9.24 5.333v-10.672l-9.24 5.339v-21.339l9.24-5.328v10.667l-9.24 5.333 9.24 5.328v-10.661l9.24-5.339z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-houzz.js
// module id = null
// module chunks = 